import { initializeApp } from 'firebase/app'
import { getAnalytics } from 'firebase/analytics'
import { getPerformance } from 'firebase/performance'
import config from '@/config/firebase'

const firebaseApp = initializeApp(config.main)
const analytics = getAnalytics(firebaseApp)
const perf = getPerformance(firebaseApp)

export default firebaseApp